import { resolveApiBaseUrl, resolveUploadUrl } from './apiBase';

const SETTINGS_CACHE_KEY = 'jaz_site_settings_v2';

const DEFAULT_SITE_SETTINGS = {
    favicon: '/favicon.png',
    loader_icon: '/images/icons/ls.svg',
    header_logo: '/images/logo/logo.png',
    header_logo_light: '/images/logo/logo-dark.png',
    company_name: 'Jaz Infotech',
    show_company_name: '1',
};

const EMPTY_SITE_SETTINGS = {
    favicon: '',
    loader_icon: '',
    header_logo: '',
    header_logo_light: '',
    company_name: '',
    show_company_name: false,
};

function resolveBaseUrl() {
    return resolveApiBaseUrl();
}

export function resolveSettingAssetUrl(path) {
    if (!path) return '';
    if (/^https?:\/\//i.test(path)) return path;
    if (path.startsWith('/uploads/')) {
        return resolveUploadUrl(path);
    }
    const prefix = process.env.PUBLIC_URL || '';
    return `${prefix}${path}`;
}

function parseShowCompanyName(raw) {
    if (raw.show_company_name === '1' || raw.show_company_name === true || raw.show_company_name === 1) {
        return true;
    }
    if (raw.show_company_name === '0' || raw.show_company_name === false || raw.show_company_name === 0) {
        return false;
    }
    return Boolean(String(raw.company_name || '').trim());
}

export function normalizeSiteSettings(raw = null) {
    if (raw === null) {
        return { ...EMPTY_SITE_SETTINGS };
    }

    return {
        favicon: raw.favicon || DEFAULT_SITE_SETTINGS.favicon,
        loader_icon: raw.loader_icon || DEFAULT_SITE_SETTINGS.loader_icon,
        header_logo: raw.header_logo || DEFAULT_SITE_SETTINGS.header_logo,
        header_logo_light: raw.header_logo_light || DEFAULT_SITE_SETTINGS.header_logo_light,
        company_name: raw.company_name || DEFAULT_SITE_SETTINGS.company_name,
        show_company_name: parseShowCompanyName(raw),
    };
}

export function readCachedSiteSettings() {
    try {
        const stored = sessionStorage.getItem(SETTINGS_CACHE_KEY);
        if (!stored) return null;
        const parsed = JSON.parse(stored);
        return normalizeSiteSettings(parsed);
    } catch (_) {
        return null;
    }
}

export function writeCachedSiteSettings(settings) {
    try {
        sessionStorage.setItem(SETTINGS_CACHE_KEY, JSON.stringify(settings));
    } catch (_) {}
}

export async function fetchPublicSiteSettings() {
    const base = resolveBaseUrl();
    try {
        const res = await fetch(`${base}/api/settings/public`, { cache: 'no-store' });
        if (!res.ok) return normalizeSiteSettings();
        const data = await res.json();
        return normalizeSiteSettings(data.data || {});
    } catch (error) {
        console.error('Site settings fetch error:', error);
        return normalizeSiteSettings();
    }
}

export { DEFAULT_SITE_SETTINGS, SETTINGS_CACHE_KEY };
